import{merge as s}from"lodash";function g({defaultSettings:r,customSettings:u}){return r.reduce((e,t)=>{const n=u.filter(m=>m.name===t.name);return n.length>0?e.push(s(t,n[0])):e.push(t),e},[])}export{g as mergeToolbarSettings};
//# sourceMappingURL=mergeToolbarSettings.js.map
